/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AppraisalPeriodDays
 */
export interface AppraisalPeriodDays {
}

/**
 * Check if a given object implements the AppraisalPeriodDays interface.
 */
export function instanceOfAppraisalPeriodDays(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AppraisalPeriodDaysFromJSON(json: any): AppraisalPeriodDays {
    return AppraisalPeriodDaysFromJSONTyped(json, false);
}

export function AppraisalPeriodDaysFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppraisalPeriodDays {
    return json;
}

export function AppraisalPeriodDaysToJSON(value?: AppraisalPeriodDays | null): any {
    return value;
}

